import type { ProductInfoRequestPayload } from '../ProductInfoRequestPayload'
import type { IUserTechnicalSalesRepository } from '../repository/IUserTechnicalSalesRepository'

export class SendProductInfoRequestUseCase {
  // eslint-disable-next-line no-useless-constructor,no-empty-function
  constructor(private userTechnicalSalesRepository: IUserTechnicalSalesRepository) {}

  async sendRequest(partnerId: string, technicianId: string, payload: ProductInfoRequestPayload) {
    if (!partnerId || !payload.to.email || !payload.product.id)
      return { status: false, message: 'required information is missing' }

    try {
      await this.userTechnicalSalesRepository.sendProductInfoRequest(partnerId, technicianId, {
        to: payload.to,
        from: payload.from,
        product: payload.product,
        text: payload.text,
      })
      return { status: true, message: '' }
    } catch (err: any) {
      return { status: false, message: err.message }
    }
  }
}
